<template>
    <div>
        <b-modal id="edit-custom-doc-location" title="Edit Location" scrollable hide-footer>
            <!-- we can add If users want to change some value here later -->
            <div class="form-group">
                <label for="defaultState">Default State</label>
                <input type="text" class="form-control" id="defaultState" v-model="defaultStateId" />
                <label for="residentState">Resident State</label>
                <input type="text" class="form-control" id="residentState" v-model="residentStateId" />
                <label for="mainLocationState">Main Location State</label>
                <input type="text" class="form-control" id="mainLocationState" v-model="mainLocationStateId" />
                <div class="newUserButtonContainer">
                    <b-button @click="closeModal('edit-custom-doc-location')">Cancel</b-button>
                    <b-button @click="saveCustomDocLocation">Edit</b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<style scoped>
.newUserButtonContainer {
    display: flex;
    justify-content: space-between;
}
</style>

<script>
import Vue from 'vue'
// resources
import CustomDocResource from '../../resources/custom_doc'
// mixins
import modalMixin from '../../mixins/modal'
import toastMixin from '../../mixins/toast'

export default Vue.extend({
    props: {
        resource: {
            required: false,
            type: Object,
            default: () => {
                return null
            },
        },
    },
    data() {
        return {
            defaultStateId: '',
            residentStateId: '',
            mainLocationStateId: '',
            customDocResource: null,
            isSaving: false,
        }
    },
    watch: {
        resource(newValue) {
            this.setInitialValues(newValue)
        },
    },
    mixins: [modalMixin, toastMixin],
    methods: {
        setInitialValues(data) {
            if (data) {
                this.defaultStateId = data.attributes.properties.locations.defaultState
                this.residentStateId = data.attributes.properties.locations.residentState
                this.mainLocationStateId = data.attributes.properties.locations.mainLocationState
            }
        },
        async saveCustomDocLocation() {
            let properties = this.resource.get('properties')
            properties.locations.defaultState = this.defaultStateId
            properties.locations.residentState = this.residentStateId
            properties.locations.mainLocationState = this.mainLocationStateId

            this.resource.set('properties', JSON.stringify(properties))
            let errors = this.resource.validate()

            if (errors.length) {
                this.handleErrors(errors)
            } else {
                try {
                    this.isSaving = true
                    const result = await this.resource.save()
                    if (result.response.status === 200 || result.response.status === 201) {
                        this.createToast('b-toaster-top-center', 'success', true, 'Custom Document Location Edited', '')
                        this.closeModal('edit-custom-doc-location')
                    }
                } catch (error) {
                    this.createToast('b-toaster-top-center', 'danger', true, 'Custom Document Edit Error', 'Error')
                    throw error
                }
                this.isSaving = false
            }
        },
    },
    computed: {
        resources() {
            return {
                CustomDocResource,
            }
        },
    },
})
</script>
